import * as React from 'react';
import { Button } from '../../../components/Button';

interface IShowMoreButtonProps {
  onClick: () => void;
  length: number;
}

export function ShowMoreButton({ onClick, length }: IShowMoreButtonProps) {
  return (
    <Button theme="blue" onClick={onClick}>
      {`Показать еще ${length} проектов`}
    </Button>
  );
}
